import React, { useState } from 'react';
import type { FC, ReactElement } from 'react';

import { Flex } from '@atlaskit/primitives';

import { Attribution, TransparentErrorBoundary } from '@confluence/error-boundary';

import { UnpublishedStateEditPermsBanner } from './UnpublishedStateEditPermsBanner';
import { useIsInCompanyHubUnpublishedState } from './useIsInCompanyHubUnpublishedState';

type CompanyHubBannerType = ReactElement | null;

type CompanyHubBannerProps = {
	spaceKey: string;
};

export const CompanyHubBanner: FC<CompanyHubBannerProps> = ({ spaceKey }): CompanyHubBannerType => {
	const [showBanner, setShowBanner] = useState<boolean>(true);
	const isInCompanyHubUnpublishedState = useIsInCompanyHubUnpublishedState(spaceKey);

	const handleOnClickClose = () => {
		setShowBanner(false);
	};

	return isInCompanyHubUnpublishedState && showBanner ? (
		<TransparentErrorBoundary attribution={Attribution.COMPANY_HUB}>
			<Flex alignItems="center">
				<UnpublishedStateEditPermsBanner handleClose={handleOnClickClose} />
			</Flex>
		</TransparentErrorBoundary>
	) : null;
};
